import React from "react";
import ContentLibraryItem from "./ContentLibraryItem";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Paper,
  Stack,
  Typography,
  LinearProgress,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Button,
  Breadcrumbs,
  Link as MUILink,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import PageHitChart from "./PageHitChart";
import Dropzone from "react-dropzone";
import DirectoryItem from "./DirectoryItem";
import ContentSettings from "./ContentSettings";
import * as ETVConstants from "../ETVConstants";
import { Add, CloudUpload, Save, FolderOpen, Settings, Timeline } from "@mui/icons-material";

import LoginWithCanvaButton from "../canva/LoginWithCanvaButton";
import CanvaDesignsList from "../canva/CanvaDesignsList";
import LoadingDialog from "../tools/LoadingDialog";
import ETVMessagePopup from "../tools/ETVMessagePopup";
import URLCreatorDialog from "../tools/URLCreatorDialog";
import ETVPage from "../tools/ETVPage";
import ETVPopup from "../tools/ETVPopup";
import ETVActionButton from "../tools/ETVActionButton";

import {
  DROPZONE_ACCEPT,
  DROPZONE_MAX_SIZE,
  uploadAndRegister,
  createUniqueStoredFilename,
  registerContent,
  stripNumericPrefix,
  isImage as utilIsImage,
  isMovie as utilIsMovie,
  isHTML as utilIsHTML,
  isPDF as utilIsPDF,
} from "./ContentLibraryUtils";

class ContentLibrary extends React.Component {
  constructor(props) {
    super(props);

    this.deleteContentID = this.deleteContentID.bind(this);
    this.setActiveF = this.setActiveF.bind(this);
    this.setPublicF = this.setPublicF.bind(this);
    this.showSettings = this.showSettings.bind(this);
    this.closeSettings = this.closeSettings.bind(this);
    this.addedToChannelLocal = this.addedToChannelLocal.bind(this);
    this.showHitReport = this.showHitReport.bind(this);
    this.closeWindow = this.closeWindow.bind(this);
    this.changeDir = this.changeDir.bind(this);
    this.deleteDir = this.deleteDir.bind(this);
    this.handleCanvaAccessToken = this.handleCanvaAccessToken.bind(this);
    this.handleCanvaSuccess = this.handleCanvaSuccess.bind(this);
    this.handleCanvaFailure = this.handleCanvaFailure.bind(this);
    this.handleCanvaClosed = this.handleCanvaClosed.bind(this);
    this.closeInfoMessage = this.closeInfoMessage.bind(this);
	this.contentSettingsRef = React.createRef();

    this.onDrop = this.onDrop.bind(this);
  }

  state = {
    isLoaded: false,
    loading: false,
    settingsID: undefined,
    window: "",
    items: [],
    info_title: "",
    info_message: "",
    info_type: "",
    available_users: [],
    current_dir: "/",
    all_dirs: [],
    new_folder_text: "",
    new_folder_error: "",
    dir_has_contents: [],
    filter_type: "*",
    filter_name: "",
    access_token: undefined,
    progress_message: "",
    spinning: false,
    library_element: null,
	content_settings_needs_save: false,
  };

  // ---------------------------- lifecycle ----------------------------
  componentDidMount() {
    this.loadData();
    if (this.props.user_id) this.loadAvailableUsers(this.props.user_id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.isLoaded && !this.state.loading) {
      this.loadData();
    }
  }

  // ---------------------------- messages/progress ----------------------------
  showInfoMessage(title, msg, isSpinning) {
    this.setState({ window: "message_div", info_type: "info", info_title: title, info_message: msg, spinning: isSpinning });
  }
  showSuccessMessage(title, msg) {
    this.setState({ window: "message_div", info_type: "success", info_title: title, info_message: msg, spinning: false });
  }
  showErrorMessage(title, msg) {
    this.setState({ window: "message_div", info_type: "error", info_title: title, info_message: msg, spinning: false });
  }
  closeInfoMessage() {
    this.setState({ window: "", info_type: "", info_title: "", info_message: undefined, spinning: false });
  }

  showProgress(message) {
    this.state.window === "progress_dialog"
      ? this.setState({ progress_message: message })
      : this.setState({ window: "progress_dialog", progress_message: message });
  }

  // ---------------------------- data loading ----------------------------
  filterOutTemplates(rx) {
    const res = [];
    for (let i = 0; i < rx.length; i++) {
      if (rx[i].content_category !== "template") res.push(rx[i]);
    }
    return res;
  }

  getSubDirs(virtualDir) {
    const res = [];
    res.push(virtualDir);
    let temp = virtualDir;
    let lastIndex = temp.lastIndexOf("/");
    while (lastIndex !== 0) {
      temp = temp.substring(0, lastIndex);
      const newEntry = temp + "/";
      if (!res.includes(newEntry)) res.push(newEntry);
      lastIndex = temp.lastIndexOf("/");
    }
    return res;
  }

  getDirs(items) {
    const res = [];
    res.push("/");
    const myID = this.props.user_id;
    for (let i = 0; i < items.length; i++) {
      const itemOwnerID = items[i].owner_id;
      if (itemOwnerID === myID) {
        const virtualDir = items[i].virtual_dir;
        const subDirs = this.getSubDirs(virtualDir);
        for (let k = 0; k < subDirs.length; k++) {
          if (!res.includes(subDirs[k])) res.push(subDirs[k]);
        }
      }
    }
    res.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    return res;
  }

  getDirHasContents(items) {
    const res = [];
    for (let i = 0; i < items.length; i++) {
      let virtualDir = items[i].virtual_dir;
      if (!virtualDir.endsWith("/")) virtualDir = virtualDir + "/";
      if (items[i].filename !== "virtual_dir") {
        res.push(virtualDir);
        const subDirs = this.getSubDirs(virtualDir);
        for (let k = 0; k < subDirs.length; k++) {
          if (!res.includes(subDirs[k])) res.push(subDirs[k]);
        }
      }
    }
    return res;
  }

  loadData() {
    this.setState({ loading: true });
    const accessToken = localStorage.getItem("etv.access_token");
    const reqUserID = localStorage.getItem("etv.user_id");
    const url = this.props.marketplace
      ? ETVConstants.getServerBase() + "/content_library?action=list_market_place"
      : ETVConstants.getServerBase() + "/content_library?action=list&user_id=" + this.props.user_id;

    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then(async (res) => {
        const result = await res.json();
        if(!res.ok || result.result===false || !Array.isArray(result.list)) {
          throw new Error(result.reason || `Request failed (${res.status})`);
        }
        return result;
      })
      .then((result) => {
        let rx = [...result.list].reverse();
        if (this.props.marketplace) rx = this.filterOutTemplates(rx);

        const allDirs = this.getDirs(rx);
        this.setState({
          isLoaded: true,
          items: rx,
          all_dirs: allDirs,
          dir_has_contents: this.getDirHasContents(rx),
          loading: false,
          filter_type: "*",
          filter_name: "",
          window: "",
          progress_message: "",
        });
      })
      .catch((error) => {
        this.setState({
          isLoaded: true,
          items: [],
          loading: false,
          filter_type: "*",
          filter_name: "",
          window: "message_div",
          info_type: "error",
          info_title: ETVConstants.trans("error") || "Error",
          info_message: error.message || String(error),
          spinning: false,
        });
      });
  }

  // ---------------------------- CRUD content flags ----------------------------
  async deleteContentID(contentID) {
    const accessToken = localStorage.getItem("etv.access_token");
    const reqUserID = localStorage.getItem("etv.user_id");
    const url = ETVConstants.getServerBase() + "/content_library?action=delete&content_id=" + contentID;

    const previousItems = this.state.items || [];
    const removedIndex = previousItems.findIndex((item) => String(item.content_id) === String(contentID));
    const removedItem = removedIndex >= 0 ? previousItems[removedIndex] : null;
    this.setState((state) => ({
      items: (state.items || []).filter((item) => String(item.content_id) !== String(contentID)),
    }));

    try {
      const response = await fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } });
      await response.text();
    } catch (error) {
      if (removedItem) {
        this.setState((state) => {
          const items = state.items || [];
          if (items.some((item) => String(item.content_id) === String(contentID))) return null;
          const restored = items.slice();
          restored.splice(Math.min(removedIndex, restored.length), 0, removedItem);
          return { items: restored };
        });
      }
      this.showErrorMessage(
        ETVConstants.trans("error") || "Error",
        error?.message || String(error)
      );
    }
  }

  setActiveF(contentID, isActive) {
    const url = ETVConstants.getServerBase() + "/content_library?action=set_active&content_id=" + contentID + "&active=" + isActive;
    this.updateContentRegistry(url);
  }
  setPublicF(contentID, isPublic) {
    const url = ETVConstants.getServerBase() + "/content_library?action=make_public&content_id=" + contentID + "&is_public=" + isPublic;
    this.updateContentRegistry(url);
  }
  updateContentRegistry(url) {
    const accessToken = localStorage.getItem("etv.access_token");
    const reqUserID = localStorage.getItem("etv.user_id");
    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(() => this.setState({ isLoaded: false }), () => {});
  }

  // ---------------------------- element helpers ----------------------------
  findElement(id) {
    for (let i = 0; i < this.state.items.length; i++) {
      if (this.state.items[i].content_id === id) return this.state.items[i];
    }
    return null;
  }

  showSettings(contentID) {
    const elem = this.findElement(contentID);
    this.setState({ library_element: elem });
    this.showWindow("content_settings_div", true);
  }

  showHitReport(contentID) {
    const elem = this.findElement(contentID);
    this.setState({ library_element: elem });
    this.showWindow("hit_report_div", true);
  }

  showWindow(divID, show) {
    show ? this.setState({ window: divID }) : this.setState({ window: "" });
  }

  closeSettings() {
    this.showWindow("content_settings_div", false);
    this.setState({ isLoaded: false });
  }

  closeWindow() {
    this.showWindow("", false);
    this.setState({ isLoaded: false });
  }

  getFilename(filename) {
    // kept signature, but now delegates to util logic
    return stripNumericPrefix(filename);
  }

  canEdit(ownerID) {
    return this.props.user_id === ownerID || (this.props.children || []).includes(ownerID);
  }

  // ---------------------------- directory logic ----------------------------
  makeInternalDirRepresentation(dir) {
    if (!dir) return "/";
    if (dir.endsWith("/")) return dir;
    return dir + "/";
  }

  filterDir(items) {
    const res = [];
    const userID = this.props.user_id;

    for (let i = 0; i < items.length; i++) {
      const filename = items[i].filename;
      const itemDir = this.makeInternalDirRepresentation(items[i].virtual_dir);

      if (filename !== "virtual_dir") {
        if (itemDir === this.state.current_dir || (items[i].owner_id !== userID && this.state.current_dir === "/")) {
          res.push(items[i]);
        }
      }
    }
    return res;
  }

  getChildrenDirs(currentDir) {
    const res = [];
    for (let i = 0; i < this.state.all_dirs.length; i++) {
      let temp = this.state.all_dirs[i];
      if (temp.endsWith("/")) temp = temp.substring(0, temp.length - 1);

      const removeStart = currentDir;
      if (temp.startsWith(removeStart)) {
        temp = temp.substring(removeStart.length);
        if (temp.length > 0 && temp.indexOf("/") === -1) {
          const candidate = removeStart + temp + "/";
          res.push(candidate);
        }
      }
    }
    return res;
  }

  changeDir(dir) {
    this.setState({ current_dir: dir });
  }

  createUpDir(curDir) {
    if (curDir === "/") return null;
    let upDir = curDir.substring(0, curDir.length - 1);
    upDir = upDir.substring(0, upDir.lastIndexOf("/") + 1);
    return upDir;
  }

  dirHasContents(dir) {
    const hasContents = this.state.dir_has_contents.includes(dir);
    if (hasContents) return true;

    for (let i = 0; i < this.state.all_dirs.length; i++) {
      if (this.state.all_dirs[i].startsWith(dir) && this.state.all_dirs[i] !== dir) return true;
    }
    return false;
  }

  randomInt(max) {
    return Math.floor(Math.random() * (max + 1));
  }
  createDirKey(dir) {
    return dir + "_" + this.randomInt(100);
  }

  // ---------------------------- filters ----------------------------
  setContains(setItems, item) {
    for (let i = 0; i < setItems.length; i++) {
      if (setItems[i] === item) return true;
    }
    return false;
  }

  filter(items) {
    if (!items) return;
    if (!this.props.excluded_ids) return items;

    const result = [];
    const excludedIDs = this.props.excluded_ids;

    for (let i = 0; i < items.length; i++) {
      if (!this.setContains(excludedIDs, items[i].content_id)) result.push(items[i]);
    }
    return result;
  }

  filterOutTV(list) {
    const res = [];
    for (let i = 0; i < list.length; i++) {
      if (list[i].filename !== "tv.tv") res.push(list[i]);
    }
    return res;
  }

  filterType(items) {
    const res = [];
    if (this.state.filter_type === "*") return this.filterOutTV(items);

    for (let i = 0; i < items.length; i++) {
      const name = items[i].filename;

      if (this.state.filter_type === "movie" && utilIsMovie(name)) res.push(items[i]);
      else if (this.state.filter_type === "image" && utilIsImage(name)) res.push(items[i]);
      else if (this.state.filter_type === "html" && utilIsHTML(name)) res.push(items[i]);
      else if (this.state.filter_type === "pdf" && utilIsPDF(name)) res.push(items[i]);
    }
    return res;
  }

  filterName(items) {
    const res = [];
    if (!this.state.filter_name || this.state.filter_name.trim().length === 0) return items;

    const filter = this.state.filter_name.trim().toLowerCase();
    for (let i = 0; i < items.length; i++) {
      const n = String(items[i].filename || "").toLowerCase();
      if (n.indexOf(filter) >= 0) res.push(items[i]);
    }
    return res;
  }

  // ---------------------------- users ----------------------------
  loadAvailableUsers(userID) {
    const accessToken = localStorage.getItem("etv.access_token");
    const reqUserID = localStorage.getItem("etv.user_id");
    const url = ETVConstants.getServerBase() + "/useradmin?action=list&user_id=" + userID;

    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then((result) => this.setState({ available_users: result.data }));
  }

  addedToChannelLocal(channel, item) {
    this.showSuccessMessage("", ETVConstants.trans("the_content_was_stored_in_your_channel"));
    if (this.props.addedToChannelF) {
      this.props.addedToChannelF(channel, item);
    }
  }

  // ---------------------------- dirs CRUD ----------------------------
  showAddDirectory() {
    this.showWindow("add_directory", true);
  }

  checkDirectoryInput(e) {
    const newValue = e.target.value;
    if (ETVConstants.isAlphaNumeric(newValue)) {
      this.setState({ new_folder_error: "", new_folder_text: newValue });
    } else {
      this.setState({ new_folder_error: "no special characters allowed" });
    }
  }

  sendAddDirectory() {
    const newDir = this.state.current_dir + this.state.new_folder_text + "/";
    if (this.state.all_dirs.includes(newDir)) {
      this.showErrorMessage(ETVConstants.trans("error"), "the directory " + newDir + " already exists");
      return;
    }

    const accessToken = localStorage.getItem("etv.access_token");
    const reqUserID = localStorage.getItem("etv.user_id");
    const userID = this.props.user_id;

    const url =
      ETVConstants.getServerBase() +
      "/content_library?action=create_virtual_directory&user_id=" +
      userID +
      "&virtual_directory=" +
      encodeURIComponent(newDir);

    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(() => {
        this.closeWindow();
        this.setState({ new_folder_text: "" });
      });
  }

  deleteDir(dir) {
    const accessToken = localStorage.getItem("etv.access_token");
    const reqUserID = localStorage.getItem("etv.user_id");
    const userID = this.props.user_id;

    const url =
      ETVConstants.getServerBase() +
      "/content_library?action=delete_virtual_directory&user_id=" +
      userID +
      "&virtual_directory=" +
      encodeURIComponent(dir);

    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(() => this.closeWindow());
  }

  // ---------------------------- Canva ----------------------------
  handleCanvaAccessToken(token) {
    this.setState({ window: "canva_design_div", access_token: token.access_token });
  }

  handleCanvaClosed() {
    this.setState({ window: "", access_token: null });
  }

  async handleCanvaSuccess(canvaUrl, thumbnail_url, filename, filetype, contentRatio) {
    this.showProgress("Saving Canva design to the library...");
    const accessToken = localStorage.getItem("etv.access_token");
    const reqUserID = localStorage.getItem("etv.user_id");
    const libraryUserID = this.props.user_id || reqUserID;
    const authHeaders = { user_id: reqUserID, access_token: accessToken };

    const storedFilename = createUniqueStoredFilename(filename);
    let url = ETVConstants.getServerBase() + "/upload_url_to_gcs?";
    url += "&filename=" + encodeURIComponent(storedFilename);
    url += "&url=" + encodeURIComponent(canvaUrl);
    url += "&target_dir=" + encodeURIComponent(`/${libraryUserID}/content_library`);
    if (thumbnail_url && thumbnail_url.length > 0) {
      url += "&thumbnail_url=" + encodeURIComponent(thumbnail_url);
    }

    try {
      const response = await fetch(url, { headers: authHeaders, cache: "no-store" });
      const result = await response.json();
      if (!response.ok || result.result === false) {
        throw new Error(result.reason || result.error || `Canva file transfer failed (${response.status})`);
      }

      this.showProgress("Registering Canva design...");
      const registration = await registerContent({
        serverBase: ETVConstants.getServerBase(),
        authHeaders,
        userID: libraryUserID,
        filename: result.filename || storedFilename,
        virtualDir: this.state.current_dir,
        contentRatio: Number.isFinite(Number(contentRatio)) ? Number(contentRatio) : -1,
        fileSize: Number(result.filesize || 0),
        desc: filename,
        thumbnailUrl: result.thumbnail_url || null,
      });

      if (registration?.result === false) {
        throw new Error(registration.reason || registration.error || "Could not register the Canva design.");
      }

      this.setState({ isLoaded: false, loading: false });
    } catch (error) {
      this.showErrorMessage(
        ETVConstants.trans("error") || "Error",
        error?.message || "The Canva design could not be added to the library.",
      );
    }
  }

  handleCanvaFailure(reason) {
	const message = typeof reason === 'string' ? reason : (reason?.message || reason?.code || 'Canva export failed.');
	this.showErrorMessage(ETVConstants.trans('error') || 'Error', message);
  }

  // ---------------------------- UI helpers ----------------------------
  renderBreadcrumbs() {
    const parts = this.state.current_dir.split("/").filter(Boolean);
    let path = "/";
    const crumbs = [
      <MUILink key="root" underline="hover" component="button" onClick={() => this.changeDir("/")}>
        /
      </MUILink>,
    ];

    parts.forEach((p, idx) => {
      path = path === "/" ? `/${p}/` : `${path}${p}/`;
      const isLast = idx === parts.length - 1;
      crumbs.push(
        <MUILink
          key={path}
          underline={isLast ? "none" : "hover"}
          component="button"
          color={isLast ? "text.primary" : "primary"}
          onClick={() => !isLast && this.changeDir(path)}
        >
          {p}
        </MUILink>
      );
    });

    const visibleCount = this.filterName(this.filterType(this.filterDir(this.state.items))).length;

    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        <FolderOpen fontSize="small" />
        <Breadcrumbs separator="/">{crumbs}</Breadcrumbs>
        <Chip size="small" label={`items: ${visibleCount}`} />
      </Stack>
    );
  }

  // ---------------------------- uploads (cleaned) ----------------------------
  async onDrop(acceptedFiles, fileRejections) {
    if (fileRejections?.length) {
      fileRejections.forEach(({ file, errors }) => {
        console.warn("Rejected:", file.name, errors.map((e) => e.code).join(", "), errors);
      });
    }

    if (!acceptedFiles || acceptedFiles.length === 0) {
      this.showErrorMessage(
        "File Error",
        "accepted files: .html, .png, .jpg, .jpeg, .gif, .bmp, .webp, .heic, .heif, .webm, .mp4, .m4v, .3gp, .pdf (max file size: 350MB)"
      );
      return;
    }

    const accessToken = localStorage.getItem("etv.access_token");
    const reqUserID = localStorage.getItem("etv.user_id");
    const authHeaders = { user_id: reqUserID, access_token: accessToken };

    this.setState({ loading: true, window: "progress_dialog", progress_message: "uploading..." });

    for (const originalFile of acceptedFiles) {
      try {
        await uploadAndRegister({
          serverBase: ETVConstants.getServerBase(),
          authHeaders,
          userID: this.props.user_id,
          file: originalFile,
          virtualDir: this.state.current_dir,
          useOnPrem: !!ETVConstants.ON_PREMISE_VERSION,
          enableHeicConversion: true,
          enableMovConversion: true,
          onStatus: (msg) => this.showProgress(msg),
          onProgress: (pct) => this.showProgress(`uploading file (${pct}%)`),
        });

        // refresh list
        this.setState({ isLoaded: false });
      } catch (err) {
        console.error(err);
        this.showErrorMessage("", `${ETVConstants.trans("error_processing_image_file") || "upload failed"}: ${err?.message || err}`);
      }
    }

    this.setState({ loading: false, window: "", progress_message: "" });
  }

  // ---------------------------- render ----------------------------
  render() {
    let items = this.filterDir(this.state.items);
    items = this.filterType(items);
    items = this.filterName(items);

    const dirs = this.getChildrenDirs(this.state.current_dir);
    const upDir = this.createUpDir(this.state.current_dir);

    const headerTitle = this.props.marketplace
      ? ETVConstants.trans("marketplace") || "Marketplace"
      : ETVConstants.trans("content_library") || "Content Library";
	const embedded = Boolean(this.props.addedToChannelF);
	const headerActions = ETVConstants.ON_PREMISE_VERSION ? null : (
	  <Stack direction="row" spacing={1}>
		{!this.props.marketplace && <LoginWithCanvaButton onAccessTokenReceived={this.handleCanvaAccessToken} />}
		{!this.props.marketplace && (
		  <Button variant="contained" startIcon={<Add />} onClick={() => this.setState({ window: "create_url_div" })}>
			{ETVConstants.trans("add_url")}
		  </Button>
		)}
	  </Stack>
	);
	const PageContainer = embedded ? Box : ETVPage;
	const pageProps = embedded
	  ? { sx: {width:'100%',py:1} }
	  : { width:'wide', icon:<FolderOpen/>, title:headerTitle, loading:this.state.loading, topActions:headerActions };

    return (
	  <PageContainer {...pageProps}>
        {embedded && !this.props.marketplace && <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
          spacing={2}
          sx={{ mb: 2 }}
        >
		  <Box sx={{display:'flex',alignItems:'center',gap:1.25}}><FolderOpen color="primary"/><Typography variant="h5" sx={{fontWeight:700}}>{headerTitle}</Typography></Box>
		  {headerActions}
        </Stack>}

        {embedded && this.state.loading && <LinearProgress sx={{ mb: 2 }} />}

        {/* Filters */}
        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "stretch", sm: "center" }}>
            <FormControl sx={{ minWidth: 220 }}>
              <InputLabel id="filter_type_lbl">{ETVConstants.trans("filter_type")}</InputLabel>
              <Select
                labelId="filter_type_lbl"
                label={ETVConstants.trans("filter_type")}
                value={this.state.filter_type}
                onChange={(e) => this.setState({ filter_type: e.target.value })}
                input={<OutlinedInput label={ETVConstants.trans("filter_type")} />}
              >
                <MenuItem value="*">{ETVConstants.trans("all_media")}</MenuItem>
                <MenuItem value="movie">{ETVConstants.trans("movies")}</MenuItem>
                <MenuItem value="image">{ETVConstants.trans("images")}</MenuItem>
                <MenuItem value="html">{ETVConstants.trans("html")}</MenuItem>
                <MenuItem value="pdf">{ETVConstants.trans("pdf")}</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label={ETVConstants.trans("filter_name")}
              value={this.state.filter_name}
              onChange={(e) => this.setState({ filter_name: e.target.value })}
              sx={{ minWidth: 260 }}
            />

            <Box sx={{ flexGrow: 1 }} />
            <Button variant="text" onClick={() => this.setState({ filter_type: "*", filter_name: "" })}>
              {ETVConstants.trans("clear_filters") || "Clear filters"}
            </Button>
          </Stack>
        </Paper>

        {/* Directory controls are only relevant to the user's content library. */}
        {!this.props.marketplace && <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
          {this.renderBreadcrumbs()}

          <Stack direction="row" spacing={1.5} sx={{ mt: 2, overflowX: "auto", pb: 1 }}>
            <Paper variant="outlined" sx={{ minWidth: 240, p: 0, overflow: "hidden" }}>
                <Dropzone
                  onDrop={this.onDrop}
                  accept={DROPZONE_ACCEPT}
                  maxSize={DROPZONE_MAX_SIZE}
                  showPreviewsInDropzone={false}
                  filesLimit={1}
                  showAlerts={false}
                >
                  {({ getRootProps, getInputProps }) => (
                    <Box
                      {...getRootProps()}
                      sx={{
                        border: "2px dashed",
                        borderColor: "divider",
                        minHeight: 180,
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        bgcolor: "background.default",
                      }}
                    >
                      <input {...getInputProps()} />
                      <Stack spacing={1} alignItems="center">
                        <CloudUpload />
                        <Typography variant="body2">{ETVConstants.trans("drag_and_drop_file_here_or_click_to_upload_a_new_file")}</Typography>
                      </Stack>
                    </Box>
                  )}
                </Dropzone>
              </Paper>

            {upDir ? <DirectoryItem key={"up"} directory={upDir} isUp={true} dirClickedFunc={this.changeDir} /> : <span />}

            {dirs.map((item) => (
              <DirectoryItem
                key={this.createDirKey(item)}
                hasContents={this.dirHasContents(item)}
                isUp={false}
                directory={item}
                deleteDirFunc={this.deleteDir}
                dirClickedFunc={this.changeDir}
              />
            ))}

            <Card sx={{ width: 140, minHeight: 180 }}>
              <CardMedia component="img" image="/icons/add_directory.png" alt="add directory" title={ETVConstants.trans("add_directory")} />
              <CardContent>
                <Typography align="center" variant="body2">
                  &nbsp;
                </Typography>
              </CardContent>
              <CardActionArea>
                <Box textAlign="center" sx={{ pb: 1 }}>
                  <Button component="span" size="small" variant="contained" color="success" startIcon={<Add />} onClick={() => this.showAddDirectory()}>
                    {ETVConstants.trans("add")}
                  </Button>
                </Box>
              </CardActionArea>
            </Card>
          </Stack>
        </Paper>}

        {/* Items grid */}
        {items && items.length > 0 ? (
          <Box
            sx={{
              display: "grid",
              gap: 1.5,
              gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
            }}
          >
            {items.map((item) => (
              <Box key={item.content_id} sx={{ minHeight: this.props.marketplace ? 0 : 210 }}>
                <ContentLibraryItem
                  key={item.content_id}
                  id={item.content_id}
                  item={item}
                  active={item.active}
                  publicF={this.setPublicF}
                  channel={this.props.channel}
                  group_id={this.props.group_id}
                  device_id={this.props.device_id}
				  marketplace={this.props.marketplace}
                  user_id={this.props.user_id}
                  children={this.props.children && this.props.children.length > 0 ? this.props.children : []}
                  showSettingsF={this.showSettings}
                  activeF={this.setActiveF}
                  deleteF={this.deleteContentID}
                  showHitReportF={this.showHitReport}
                  user_roles={this.props.roles}
                  available_users={this.state.available_users}
                  addedToChannelF={this.props.addedToChannelF ? () => this.addedToChannelLocal(this.props.channel, item) : undefined}
                />
              </Box>
            ))}
          </Box>
        ) : (
          <Paper variant="outlined" sx={{ p: 4, textAlign: "center" }}>
            <Typography variant="body1" color="text.secondary">
              {ETVConstants.trans("no_content_found") || "No content found for this folder/filter."}
            </Typography>
          </Paper>
        )}

        {/* Dialogs */}
        <ETVMessagePopup
          type={this.state.spinning ? "progress" : (this.state.info_type || "info")}
          open={this.state.window === "message_div"}
          onClose={this.closeInfoMessage}
          title={this.state.info_title}
          message={this.state.info_message}
        />

        <ETVPopup
          open={this.state.window === "content_settings_div"}
          onClose={() => this.setState({ window: "", isLoaded: false })}
          width="standard"
          icon={<Settings />}
          title={ETVConstants.trans("content_settings")}
          closeButton
		  bottomActions={
			<>
            <ETVActionButton
              action="cancel"
              label={ETVConstants.trans("close")}
              onClick={() => this.setState({ window: "", isLoaded: false })}
            />
			{this.state.library_element && this.canEdit(this.state.library_element.owner_id) &&
			  <ETVActionButton
				action="save"
				disabled={!this.state.content_settings_needs_save}
				onClick={()=>this.contentSettingsRef.current?.saveSettings()}
			  />
			}
			</>
          }
        >
            <ContentSettings
			  ref={this.contentSettingsRef}
              closeF={this.closeSettings}
              user_roles={this.props.roles}
              library_element={this.state.library_element}
              user_id={this.props.user_id}
              editable={this.state.library_element ? this.canEdit(this.state.library_element.owner_id) : false}
			  onChanged={(changed)=>this.setState({content_settings_needs_save:changed})}
            />
        </ETVPopup>

        <ETVPopup
          open={this.state.window === "hit_report_div"}
          onClose={() => this.setState({ window: "" })}
          width="wide"
          icon={<Timeline />}
          title={ETVConstants.trans("hit_report")}
          bottomActions={<ETVActionButton action="cancel" label={ETVConstants.trans("close")} onClick={() => this.setState({ window: "" })} />}
        >
            {this.state.library_element ? (
              <PageHitChart
                content_id={this.state.library_element.content_id}
                chart_title={this.getFilename(this.state.library_element.filename)}
                closeF={this.closeWindow}
              />
            ) : (
              <span />
            )}
        </ETVPopup>

        <URLCreatorDialog
          open={this.state.window === "create_url_div"}
          onClose={() => this.setState({ window: "" })}
          onAdded={() => this.setState({ window: "", isLoaded: false })}
        />

        <Dialog open={this.state.window === "add_directory"} maxWidth="xs" fullWidth>
          <DialogTitle>{ETVConstants.trans("add_directory")}</DialogTitle>
          <DialogContent dividers>
            <TextField
              required
              helperText={this.state.new_folder_error}
              error={this.state.new_folder_error.length > 0}
              label={ETVConstants.trans("foldername") || "foldername"}
              inputProps={{ maxLength: 50 }}
              fullWidth
              value={this.state.new_folder_text}
              onChange={(e) => this.checkDirectoryInput(e)}
            />
          </DialogContent>
          <DialogActions>
            <Button size="small" onClick={() => this.setState({ window: "" })} color="primary">
              {ETVConstants.trans("close")}
            </Button>
            <Button
              size="small"
              variant="contained"
              disabled={this.state.new_folder_text.length === 0}
              onClick={() => this.sendAddDirectory()}
              startIcon={<Save />}
            >
              {ETVConstants.trans("save")}
            </Button>
          </DialogActions>
        </Dialog>

        <ETVPopup
          open={this.state.window === "canva_design_div"}
          onClose={this.handleCanvaClosed}
          width="wide"
          icon={<img src="/logo/Canva_Icon_logo.svg" width="34" height="34" alt="Canva" />}
          title="Canva Import"
          description="Select a Canva design and choose an available download format."
          contentSx={{ bgcolor:'grey.50', maxHeight:'min(72vh, 820px)', overflowY:'auto' }}
          bottomActions={
            <ETVActionButton action="cancel" label={ETVConstants.trans("close") || "Close"} onClick={this.handleCanvaClosed}/>
          }
        >
            {this.state.access_token ? (
              <CanvaDesignsList
                accessToken={this.state.access_token}
                exportSuccess={this.handleCanvaSuccess}
                exportFailure={this.handleCanvaFailure}
              />
            ) : (
              <span />
            )}
        </ETVPopup>

        <LoadingDialog open={this.state.window === "progress_dialog"} message={this.state.progress_message || "loading..."} />
      </PageContainer>
    );
  }
}

export default ContentLibrary;
